/**
 * Compact usage chip for free-tier caps ("24/30 today").
 *   • Neutral gray for < 75% used
 *   • Amber for 75-99% used
 *   • Rose for hit the cap (100%)
 * Tapping the chip navigates to /upgrade so users have a single obvious path
 * out when they get close.
 */
export function UsageChip({ used, limit, label, onClick }) {
  const pct = limit > 0 ? used / limit : 0;
  const remaining = Math.max(0, limit - used);
  const tone =
    pct >= 1
      ? "border-rose-500/50 bg-rose-500/15 text-rose-200"
      : pct >= 0.75
      ? "border-amber-500/40 bg-amber-500/10 text-amber-200"
      : "border-white/10 bg-white/[0.04] text-neutral-300 hover:bg-white/[0.08]";
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="usage-chip-messages"
      title={`${remaining} messages left ${label}. Tap to upgrade.`}
      className={`shrink-0 flex items-center gap-1 rounded-full border px-2 py-1 text-[10px] font-medium tracking-wide transition ${tone}`}
    >
      <span>{used}/{limit}</span>
      <span className="hidden sm:inline text-neutral-500">·</span>
      <span className="hidden sm:inline uppercase tracking-widest text-[9px] opacity-80">{label}</span>
    </button>
  );
}
